<template>
  <section class="section">
    <section class="h-panel">
      <ValidationObserver ref="observer" v-slot="{ valid }">
        <h3>Set New Password</h3>
        <h-input
          name="email"
          ref="email_field"
          :model="formProps.email"
          :schema="schema.email"
          :showErrors="false"
          inputType="email"
          disabled
        ></h-input>
        <input
          style="position: absolute; z-index: -1; top: 20px; width: 0; height:0"
          type="email"
          name="email"
          autocomplete="new-password"
        />
        <h-input
          name="password"
          :model="formProps.password"
          :schema="schema.password"
          :showErrors="false"
          :showPlaceholder="false"
          inputType="password"
          focusOnMount
          @password-edited="formProps.password = $event"
        ></h-input>
        <div
          class="level is-mobile is-size-7 has-text-weight-semibold modal-buttons"
          style="margin-top: 0.5rem"
        >
          <div class="level-left">
            <span class="help-text">Need help?</span>
            <a href="mailto:help@holos.io"> <u>Contact Support</u> </a>
          </div>
        </div>
        <footer class="" style="justify-content: flex-end;">
          <div class="buttons modal-buttons">
            <b-button
              class="is-primary"
              size="is-large"
              :disabled="!valid || processing"
              :loading="processing"
              @click="submit"
              >Reset and Login</b-button
            >
          </div>
        </footer>
      </ValidationObserver>
    </section>
  </section>
</template>

<script>
import schema from "@/assets/schemas/fields/users.schema.js";
import { ValidationObserver } from "vee-validate";
import Users from "@/common/resources/Users.module.js";

export default {
  components: { ValidationObserver },
  data() {
    return {
      schema,
      processing: false,
      formProps: {
        email: this.$route.query.email, // fill in the email field of the form
        password: undefined,
      },
      message: undefined,
    };
  },
  methods: {
    async submit() {
      this.processing = true;
      new Users(this.formProps)
        .$resetPassword(this.$route.query.token)
        .then(() => {
          this.processing = false;
          this.$router.push("/"); // direct to home page
        })
        .catch(() => {
          // Errors throwin in user.$login() and user.$resetPassword come here.  Toast has already been launched in the catch block of Users.Module@resetPassword
          this.processing = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.h-panel {
  max-width: 500px;
}

.help-text {
  margin-right: 5px;
}

footer {
  display: flex;
}
</style>
